import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "../Components/ui/Button";

const links = [
  { name: "Home", to: "/", hash: "#home" },
  { name: "Services", to: "/services" },
  { name: "Work", to: "/work" },
  { name: "Blog", to: "/blog" },
  { name: "About", to: "/about" },
  { name: "Careers", to: "/careers" },
  { name: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goContact = () => {
    if (location.pathname === "/contact") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (location.pathname === "/") {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/contact";
    }
  };

  const hrefFor = (link) => (link.hash ? `${link.to}${link.hash}` : link.to);

  return (
    <nav
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled
          ? "border-b border-zinc-200 bg-white/95 py-2 shadow-sm backdrop-blur-md"
          : "border-b border-zinc-100/80 bg-white/90 py-3 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/Artboardcopy1.png" alt="Quantum Spark Technology logo" className="h-7 w-7 object-contain" />
          <span className="font-display text-base font-bold tracking-tight text-brand-ink">Quantum Spark Technology</span>
        </Link>

        <div className="hidden items-center gap-6 md:flex">
          <div className="flex items-center gap-6 text-sm font-medium text-brand-muted">
            {links.map((link) => (
              <Link key={link.name} to={hrefFor(link)} className="transition-colors hover:text-brand-purple">
                {link.name}
              </Link>
            ))}
          </div>
          <Button
            className="h-9 rounded-full bg-brand-purple px-5 text-sm font-medium text-white shadow-sm hover:bg-brand-purple-dark"
            onClick={goContact}
          >
            Get a Quote
          </Button>
        </div>

        <button type="button" className="text-brand-ink md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="absolute top-full left-0 flex w-full flex-col gap-4 border-b border-zinc-200 bg-white p-6 shadow-lg md:hidden">
          {links.map((link) => (
            <Link
              key={link.name}
              to={hrefFor(link)}
              className="border-b border-zinc-100 py-2 text-lg font-medium text-brand-ink last:border-0"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Button
            className="mt-2 w-full justify-center rounded-full bg-brand-purple text-white"
            onClick={() => {
              setMobileMenuOpen(false);
              goContact();
            }}
          >
            Get a Quote
          </Button>
        </div>
      )}
    </nav>
  );
}
